import { useDispatch } from 'react-redux'
import DetailTemplate from '@/components/DetailTemplate'
import {Toggle, Tooltip } from '@/components/ui'
import { formatDays } from '@/utils/formatters'

import { useBienContext } from '../BienContext'
import { updateEntretienRegulierBien } from '../biensSlice'

export default () => {
  const dispatch = useDispatch()
  const { bien, loading, updatedSections } = useBienContext()

  const SECTION_ID='types_entretiens'
  const SECTION_TITLE='Type d\'entretiens réguliers'

  const handleToggleClick = (entretienRegulierID) => {
    const type = bien.entretiens_reguliers.find( item => item.id === entretienRegulierID)
    if(type) {
      dispatch(updateEntretienRegulierBien({
        id: bien.id, 
        nom: type.nom,
        data: {
          entretien_type_id: type.entretien_type_id,
          is_regulier: !type.is_regulier
        }
      }))
    } else {
      console.error("no entretien regulier item corresponding for current bien")
    }
  }

  return (
    <DetailTemplate
      sectionId={SECTION_ID}
      title={SECTION_TITLE}
      loading={loading}
      isPendingAction={loading}
      bodyProps={{columns: 1}}
      updatedSections={updatedSections}
    >
      <div className='flex space-x-2'>
        { (!bien.entretiens_reguliers || bien.entretiens_reguliers.length == 0) &&
          <div><p>Aucun entretien régulier</p></div>
        }
        { bien.entretiens_reguliers && bien.entretiens_reguliers.length > 0 &&
          bien.entretiens_reguliers?.map(
            entretien_type => (
              <Tooltip key={entretien_type.id}
                className='flex items-center'
                text={entretien_type.is_regulier ? `renouvellement ${formatDays(entretien_type.frequence_jours)}` : ''}
              >
                <Toggle.Display label={entretien_type.nom || "Type d'entretien indéfini"} labelSuffix=''
                  value={entretien_type.is_regulier}
                  className='flex items-center'
                  cursor='cursor-pointer'
                  onClick ={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    handleToggleClick(entretien_type.id)
                  }}
                />
              </Tooltip> 
            )
          )
        }
      </div>
    </DetailTemplate>
  )
}